module.exports = __webpack_public_path__ + "r-c-bg.png?1e08bb6293ab2e188ae222a244f8fa37";


//////////////////
// WEBPACK FOOTER
// ./static/images/r-c-bg.png
// module id = 67
// module chunks = 26